import { useEffect } from "react";
import { useReCaptcha } from "./use-re-captcha";
type ReCaptchaProps = {
  action?: string;
  onVerify: (token: string) => void | Promise<void>;
  onError?: (error: unknown) => void | Promise<void>;
};

/** @deprecated Please use the `useRecaptcha` hook instead */
export function ReCaptcha({
  action,
  onVerify,
  onError
}: ReCaptchaProps): null {
  const context = useReCaptcha();
  useEffect(function initRecaptchaToken() {
    async function executeRecaptcha(): Promise<void> {
      try {
        const result = await context.execute(action);
        if (result.isError) return onError?.(result.error);
        return onVerify(result.value);
      } catch (error) {
        return onError?.(error);
      }
    }
    context.onLoad(executeRecaptcha);
  }, [action, context, onError, onVerify]);
  return null;
}